import React from "react";

import BarSortingEditor from "../../../components/Task/types/BarSorting/editor";
import BarSorting2Editor from "../../../components/Task/types/BarSorting2/editor";
import BarlineEditor from "../../../components/Task/types/Barline/editor";
import RhytSortingEditor from "../../../components/Task/types/RhytSorting/editor";
import MelodyTableEditor from "../../../components/Task/types/MelodyTable/editor";
import TonesetStaffEditor from "../../../components/Task/types/TonesetStaff/editor";
import FlowEditor from "../../../components/Task/types/Flow/editor";
import SingingEditor from "../../../components/Task/types/Singing/editor";
import RhytNameEditor from "../../../components/Task/types/RhytName/editor";
import RhytKnockEditor from "../../../components/Task/types/RhytKnock/editor";
import RhytNotationEditor from "../../../components/Task/types/RhytNotation/editor";
import SolfaNameEditor from "../../../components/Task/types/SolfaName/editor";
import HandSignEditor from "../../../components/Task/types/HandSign/editor";
import IntervalsEditor from "../../../components/Task/types/Intervals/editor";
import PianoEditor from "../../../components/Task/types/Piano/editor";
import EmbedEditor from "../../../components/Task/types/Embed/editor";
import SubScoreEditor from "../../../components/Task/types/SubScore/editor";
import Chords3Editor from "../../../components/Task/types/Chords3/editor";

import { IProps } from "./interfaces";

const EditorContainer = ({
    viewProps,
    publicView,
    plan,
    taskIndex,
    toggleInlineEditor,
    inlineEditorOpen,
    playable,
    reload,
    isScaleAlert,
    flowPage,
    changeFlowPage,
}: IProps) => {
    const props = {
        toggleInlineEditor,
        viewProps,
        publicView,
        taskIndex,
        plan,
        inlineEditorOpen,
        playable,
        reload,
        isScaleAlert,
        flowPage,
        changeFlowPage,
    } as any;
    const { type } = plan.tasks[taskIndex];
    return (
        <>
            {type === "barSorting" && <BarSortingEditor {...props} />}
            {type === "barSorting2" && <BarSorting2Editor {...props} />}
            {type === "barline" && <BarlineEditor {...props} />}
            {type === "rhytSorting" && <RhytSortingEditor {...props} />}
            {type === "melodyTable" && <MelodyTableEditor {...props} />}
            {type === "tonesetStaff" && <TonesetStaffEditor {...props} />}
            {type === "flow" && <FlowEditor {...props} />}
            {type === "singing" && <SingingEditor {...props} />}
            {type === "rhytName" && <RhytNameEditor {...props} />}
            {type === "rhytKnock" && <RhytKnockEditor {...props} />}
            {type === "subScore" && <SubScoreEditor {...props} />}
            {type === "rhytNotation" && <RhytNotationEditor {...props} />}
            {type === "solfaName" && <SolfaNameEditor {...props} />}
            {type === "handSign" && <HandSignEditor {...props} />}
            {type === "intervals" && <IntervalsEditor {...props} />}
            {type === "chords3" && <Chords3Editor {...props} />}
            {type === "piano" && <PianoEditor {...props} />}
            {type === "embed" && <EmbedEditor {...props} />}
        </>
    );
}

export default EditorContainer;
